import { useRegisterSW } from 'virtual:pwa-register/react';

export const SHOW_RELEASE_NOTES_KEY = 'showReleaseNotesAfterUpdate';

export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh || window.location.pathname === '/landing') return null;

  const handleUpdate = () => {
    localStorage.setItem(SHOW_RELEASE_NOTES_KEY, 'true');
    updateServiceWorker(true);
  };

  return (
    <div className="fixed bottom-20 left-0 right-0 z-[1100] flex justify-center px-4 pointer-events-none">
      <div className="flex items-center gap-3 bg-gray-900 text-white text-sm rounded-xl px-4 py-3 shadow-lg pointer-events-auto max-w-sm w-full">
        <span className="flex-1">新しいバージョンがあります</span>
        <button
          onClick={handleUpdate}
          className="bg-primary text-white text-xs font-medium px-3 py-1.5 rounded-lg whitespace-nowrap"
        >
          更新する
        </button>
      </div>
    </div>
  );
}
